import { isDiff } from '~/web-frontend-core/helpers/isDiffDefinder/isDiff';
import { objectMerger } from './helpers/objectMerger';
export class Base {
    constructor() {
        this.subscribers = [];
    }
    init(config) {
        this.config = config;
        this.listener = new this.listenerClass(this.config);
        this.connect();
    }
    reInit(config) {
        this.init(config);
        this.connect();
    }
    connect() {
        this.listener.subscribe(Object.assign(Object.assign({}, this.config), { onmessage: this.save.bind(this) }));
    }
    save(data) {
        if (isDiff(data)) {
            this.data = this.adapter(objectMerger(this.data, data));
            this.update();
        }
        else {
            this.data = this.adapter(data);
            this.update();
        }
    }
    update() {
        this.subscribers.forEach(fn => fn(this.data));
    }
    subscribe(fn) {
        this.subscribers.push(fn);
    }
    unsubscribe(fn) {
        this.listener.unsubscribe(fn);
        this.subscribers = this.subscribers.filter(sub => sub !== fn);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/core/Base.js